import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'

interface AuthRouteProps {
  children: React.ReactNode
}

const FIRST_VISIT_KEY = 'hasVisitedBoot'

// 检查token是否有效的函数
const isTokenValid = (token: string | null): boolean => {
  if (!token) return false
  
  try {
    return token.trim().length > 0
  } catch (error) {
    console.error('Token validation error:', error)
    return false
  }
}

// 检查用户是否已登录
const isAuthenticated = (): boolean => {
  const token = localStorage.getItem('token')
  return isTokenValid(token)
}

const AuthRoute: React.FC<AuthRouteProps> = ({ children }) => {
  const location = useLocation()
  
  // 如果已登录，重定向到首页或之前访问的页面
  if (isAuthenticated()) {
    // 获取之前想要访问的页面，如果没有则跳转到首页
    const from = (location.state as any)?.from?.pathname || '/home'
    return <Navigate to={from} replace />
  }

  // 如果未登录，检查是否需要先访问引导页
  const hasVisitedBoot = localStorage.getItem(FIRST_VISIT_KEY)
  if (!hasVisitedBoot && location.pathname !== '/boot') {
    // 未访问过引导页且当前不在引导页，强制重定向到引导页
    return <Navigate to="/boot" replace />
  }

  // 如果未登录且已访问过引导页，正常渲染认证相关页面
  return <>{children}</>
}

export default AuthRoute